// Dependencias generales
import React from "react";

import logoEfergy from '../../img/brands/efergy.svg'
import logoEwelink from '../../img/brands/ewelink.svg'
import logoFusionSolar from '../../img/brands/fusion-solar.svg' 
import logoSmartlife from '../../img/brands/smart-life.svg'
import logoTuya from '../../img/brands/tuya.svg'
import logoTesla from '../../img/brands/tesla.svg'
import logoTplink from '../../img/brands/tplink.svg'
import logoVictron from '../../img/brands/victron.svg'
import logoHelias from '../../img/brands/helias.png'
import logoShelly from '../../img/brands/shelly.svg'
import logoTAPO from '../../img/brands/tapo.svg'
import logoARISTON from '../../img/brands/ariston-net.svg'
import logoBRONPI from '../../img/brands/bronpi.svg'
import logoSOLARWEB from '../../img/brands/solarweb.svg'
import logoECOFORESTCONTROL from '../../img/brands/ecoforest-control.svg'
import logoBROADLINK from '../../img/brands/broadlink.svg'
import logoHOME_ASSISTANT from '../../img/brands/homeassistant.svg'
import logoKOSTAL from '../../img/brands/kostal.svg'
import logoIberdrolaSmartMonitor from '../../img/brands/IberdrolaSmartMonitor.svg'
import logoEnergeeks30 from '../../img/brands/energeeks30.svg'
import logoSolarman from '../../img/brands/solarmansmart.svg'
import logoEDPSolar from '../../img/brands/edp-solar.svg'
import logoESAJHome from '../../img/brands/esaj-home.svg'
import logoiAquaLink from '../../img/brands/iaqualink.svg'
import logoMELCloud from '../../img/brands/MELCloud.svg'
import logoComfortCloud from '../../img/brands/panasonic-comfort-cloud-app.svg'
import logoMeross from '../../img/brands/meross.svg'
import logoOnecta from '../../img/brands/daikin-onecta.svg'
import logoGovee from '../../img/brands/govee-home.svg'
import logoXiaomi from '../../img/brands/xiaomi-home.svg'
import logoSmartThings from '../../img/brands/smartthings.svg'

// Función del router
const AppLogoImg = (params) => {
  
  function obtenerImagen(app){

    var imgLogo = ""
  
    if(app === "EFERGY"){imgLogo = logoEfergy}
    else if(app === "EWELINK"){imgLogo = logoEwelink}
    else if(app === "FUSIONSOLAR"){imgLogo = logoFusionSolar}    
    else if(app === "SMARTLIFE"){imgLogo = logoSmartlife}
    else if(app === "TUYA"){imgLogo = logoTuya}
    else if(app === "TESLA"){imgLogo = logoTesla}
    else if(app === "TPLINK"){imgLogo = logoTplink}
    else if(app === "VICTRON"){imgLogo = logoVictron}
    else if(app === "HELIAS"){imgLogo = logoHelias}
    else if(app === "SHELLY"){imgLogo = logoShelly}
    else if(app === "TAPO"){imgLogo = logoTAPO}
    else if(app === "ARISTON"){imgLogo = logoARISTON}
    else if(app === "BRONPI"){imgLogo = logoBRONPI}
    else if(app === "SOLARWEB"){imgLogo = logoSOLARWEB}
    else if(app === "ECOFORESTCONTROL"){imgLogo = logoECOFORESTCONTROL}
    else if(app === "BROADLINK"){imgLogo = logoBROADLINK}
    else if(app === "HOME_ASSISTANT"){imgLogo = logoHOME_ASSISTANT}
    else if(app === "KOSTAL"){imgLogo = logoKOSTAL}
    else if(app === "KOSTAL_LOCAL"){imgLogo = logoKOSTAL}
    else if(app === "IBERDROLA_SMART_MONITOR"){imgLogo = logoIberdrolaSmartMonitor}
    else if(app === "EDP_SOLAR"){imgLogo = logoEDPSolar}
    else if(app === "ENERGEEKS_30"){imgLogo = logoEnergeeks30}
    else if(app === "SOLARMAN"){imgLogo = logoSolarman}
    else if(app === "ESAJ_HOME"){imgLogo = logoESAJHome}
    else if(app === "IAQUALINK"){imgLogo = logoiAquaLink}
    else if(app === "MELCLOUD"){imgLogo = logoMELCloud}   
    else if(app === "COMFORT_CLOUD"){imgLogo = logoComfortCloud}   
    else if(app === "MEROSS"){imgLogo = logoMeross}
    else if( (app === "ONECTA_DAIKIN") || (app === "ONECTADAIKIN") ){imgLogo = logoOnecta}
    else if(app === "GOVEE"){imgLogo = logoGovee}
    else if(app === "XIAOMI"){imgLogo = logoXiaomi}
    else if(app === "SMARTTHINGS"){imgLogo = logoSmartThings}

    return imgLogo   
  
  }

  return (           
    <img id={params.id} src={obtenerImagen(params.aplicacion)} alt={params.aplicacion}/>
  )
}

export default AppLogoImg